module.exports = __webpack_public_path__ + "img/DAG.1bf1021c.png";